import React, { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import {
	Row,
	Card,
	CardBody,
	Col,
	Label,
	CardText,
	Input,
	CardTitle,
} from "reactstrap";
import useCurrentDealStore from "stores/DealStore";
import useCurrentSaleStore from "stores/SaleStore";
import shallow from "zustand/shallow";

const DmvFeeTax = () => {
	const { miscDMVFees, dmvTaxRate } = useCurrentDealStore(
		(state) => ({
			miscDMVFees: state.miscDMVFees,
			dmvTaxRate: state?.deal?.dealSettings.taxDefaults?.dmvTaxRate,
		}),
		shallow
	);
	const { taxRate } = useCurrentSaleStore(
		(state) => ({
			taxRate: state.taxRate,
		}),
		shallow
	);

	const [tRate, setTRate] = useState(0);
	useEffect(() => {
		if (dmvTaxRate > 0) {
			setTRate(dmvTaxRate);
		} else {
			setTRate(taxRate);
		}
	}, [taxRate, dmvTaxRate]);

	const Currency = ({ value }) => {
		return (
			<NumberFormat
				value={value}
				thousandSeparator={true}
				decimalScale={2}
				fixedDecimalScale={true}
				prefix={"$"}
				isNumericString={true}
				displayType="text"
			/>
		);
	};

	const Percent = ({ value }) => {
		return (
			<NumberFormat
				value={value * 100}
				decimalScale={2}
				fixedDecimalScale={true}
				suffix={"%"}
				isNumericString={true}
				displayType="text"
			/>
		);
	};

	return (
		miscDMVFees.length > 0 && (
			<Card className="w-100 my-3">
				<h5 className="p-2">DMV Fees</h5>
				<CardTitle className="px-4">
					{miscDMVFees.length < 1 &&
						"There is no additional DMV fee in this deal."}
				</CardTitle>
				<CardBody>
					{miscDMVFees.map((element) => (
						<>
							<Row>
								<Col>
									<Label>{element.type}</Label>
								</Col>
								<Col>
									<CardText className="px-5">
										<Input type="checkbox" checked={element.isTaxable} />
									</CardText>
								</Col>
								<Col>
									<CardText>
										<Currency value={element.amount} />
									</CardText>
								</Col>
								<Col>
									<CardText>
										<Percent value={element.isTaxable ? tRate : 0} />
									</CardText>
								</Col>
								<Col>
									<CardText>
										<Currency
											value={element.isTaxable ? tRate * element.amount : 0}
										/>
									</CardText>
								</Col>
							</Row>

							<hr />
						</>
					))}
				</CardBody>
			</Card>
		)
	);
};

export default DmvFeeTax;
